import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';

export class ServiceViewModel extends DrObject {
    model: Partial<Service>;
    constructor(value?: Partial<Service>) {
        super(DrObjectType.SERVICE);
        if (value) {
            this.model = value;
        }
    }
}

export class Service extends DrEntity {
    name: string;
    handle: string;
    description: string;
    serviceName: string;
    serviceNodes: string;
    serviceExpressNodes: Array<any>;
    serviceOcrNodes: Array<any>;
    serviceRealmNodes: Array<any>;
    analyticNodeMode: string;
    selectedRealmNodes: Array<any>;

    constructor(value?: Partial<Service>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}
